(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var sectionHeader = document.querySelector(".section--header");
    var firstMainSection = document.querySelector("main .shopify-section");
    var darkSection = firstMainSection.querySelector("#main-content .shopify-section:first-child .section-theme-dark");
    var announcementSection = document.querySelector("#shopify-section-announcement");
  
    if (darkSection) {
      sectionHeader.classList.add("dark")

      function firstSectionPadding() {
        var headerHeight = sectionHeader.querySelector(".header--root").offsetHeight;
        firstMainSection.style.paddingTop = headerHeight + "px";
      }

      firstSectionPadding();;
    }
  
  
    function addTop() {
      if (announcementSection) {
        var announcementHeight = announcementSection.offsetHeight;
        sectionHeader.style.top = announcementHeight + "px";
      }
    }
  
    addTop();
  
    window.addEventListener('resize',() => {    
      firstSectionPadding();
      addTop();
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function setSlidesMinHeight() {
        var slides = document.querySelectorAll('.carousel--block .featured-content--container');
        var maxHeight = 0;
        var minHeight = window.innerHeight * 0.8;

        slides.forEach(function (slide) {
            var slideHeight = slide.offsetHeight;
            maxHeight = Math.max(maxHeight, slideHeight);
        });

        if (maxHeight < minHeight) {
            maxHeight = minHeight;
        }

        slides.forEach(function (slide) {
            slide.style.height = maxHeight + "px";
        });
    }

    if (window.innerWidth <= 768) {
        setSlidesMinHeight();
    }

    window.addEventListener('resize', function () {
        if (window.innerWidth <= 768) {
            setSlidesMinHeight();
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
